import { Controller } from '@hotwired/stimulus';

export default class BlogCategoriesController extends Controller<HTMLElement> {
  static targets = ['active'];

  declare readonly activeTarget: HTMLElement;

  async connect(): Promise<void> {
    // Avant le chargement des polices, les chips ont la largeur de la police
    // de repli : la catégorie courante finirait décalée.
    await document.fonts.ready;

    const row = this.element.getBoundingClientRect();
    const chip = this.activeTarget.getBoundingClientRect();
    const padding = parseFloat(getComputedStyle(this.element).paddingLeft);
    // Déjà visible, elle reste où elle est : faire défiler cacherait « Tous »
    // sans rien pour signaler qu'on peut revenir en arrière.
    if (chip.right <= row.right - padding) return;

    this.element.scrollLeft += chip.left - row.left - padding;
  }
}
